import debug from 'debug';
const log = debug('localize-date');

class LocalizeDate {
	constructor(element) {
		log('element', element);

		this.options = {
			utcdate: element.dataset['localizeDateUtcdate'],
			dateFormat:
				element.dataset['localizeDateDateFormat'] || 'd M yyyy, h:mmtt',
			monthFormat: element.dataset['localizeDateMonthFormat'] || 'short'
		};
		this.element = element;

		var stringDate = this.date2str(
			new Date(this.options.utcdate),
			this.options.dateFormat,
			this.options.monthFormat
		);

		log(stringDate);
		this.element.innerText = stringDate;
		log('ready', this, this.element);
	}

	getMonthName(date, format) {
		return date.toLocaleString('default', { month: format });
	}

	getDayName(date, format) {
		return new Intl.DateTimeFormat('en-AU', { weekday: format }).format(date);
	}

	getAmPm(date) {
		return date
			.toLocaleString('default', { hour: 'numeric', hour12: true })
			.split(' ')[1];
	}

	date2str(date, format, monthFormat) {
		var z = {
			M: this.getMonthName(date, monthFormat),
			D: this.getDayName(date, 'long'),
			d: date.getDate(),
			h: (date.getHours() + 24) % 12 || 12,
			m: date.getMinutes(),
			s: date.getSeconds(),
			t: this.getAmPm(date),
			y: date.getFullYear().toString()
		};
		format = format.replace(/(M+|D+|d+|h+|m+|s+|t+|y+)/g, function (v) {
			var needsPadding =
				v.length > 1 &&
				(v.indexOf('d') >= 0 ||
					v.indexOf('h') >= 0 ||
					v.indexOf('m') >= 0 ||
					v.indexOf('s') >= 0);

			var result = z[v.slice(-1)];
			if(v.indexOf('y') >= 0) {
				result = result.slice(-v.length);
			}
			return ((needsPadding ? '0' : '') + result).slice(
				needsPadding ? -2 : 0
			);
		});

		return format;
	}
}

export default LocalizeDate;



// WEBPACK FOOTER //
// ./project/client/src/core/modules/localize-date/localize-date.js